import { COLORS } from '../../constants/style/color';
import { Spinner } from './spinner.styled';

interface SpinnersType {
  borderColor?: string;
  className?: string;
  containerClassName?: string;
  size?: 'sm' | 'md' | 'lg';
  id?: string;
}

const Spinners = ({
  borderColor,
  className,
  containerClassName,
  size,
  id,
  ...rest
}: SpinnersType): JSX.Element => {
  return (
    <div className={`flex items-center justify-center ${containerClassName ?? ''}`}>
      <Spinner
        id={id}
        borderColor={borderColor ?? COLORS.Blue}
        size={size ?? 'lg'}
        className={className}
        {...rest}
      />
    </div>
  );
};

export default Spinners;
